import CreateCredentialsMessages from 'messages/CreateCredentials/CreateCredentials.json';

export enum ErrorCode {
  BAO_BUS_001 = 'BAO_BUS_001',
}

export enum CreateProfileStep {
  CREDENTIALS_STEP = 1,
  PERSONAL_INFO_STEP = 2,
}

export const ANALYTICS_EVENT = {
  PROFILE_CREDENTIALS: {
    currentStep: 'profile creation',
    eventInfo: {
      ucsId: 'UCS-bao-002',
    },
    step: {
      stepId: '2',
      flowId: 'profile creation',
    },
  },
  EXISTS_EMAIL: {
    currentStep: 'already existing customer',
    eventInfo: {
      ucsId: 'UCS-bao-003',
      interaction: `warning:${CreateCredentialsMessages.en['createCredentials.emailAlreadyExistsTitle']}`,
    },
    step: {
      stepId: '3',
      flowId: 'profile creation',
    },
  },
  EXISTS_APPLICATION: {
    currentStep: 'already existed application',
    eventInfo: {
      ucsId: 'UCS-bao-003',
      interaction: `warning:${CreateCredentialsMessages.en['createCredentials.existedApplicationTitle']}`,
    },
    step: {
      stepId: '3',
      flowId: 'profile creation',
    },
  },
  PROFILE_PERSONAL_INFO: {
    currentStep: 'personal information',
    eventInfo: {
      ucsId: 'UCS-bao-004',
    },
    step: {
      stepId: '4',
      flowId: 'profile creation',
    },
  },
  CREATING_PROFILE: {
    currentStep: 'profile creation processing',
    eventInfo: {
      ucsId: 'UCS-bao-005',
    },
    step: {
      stepId: '5',
      flowId: 'profile creation',
    },
  },
  PROFILE_CREATION_CONFIRMATION: {
    currentStep: 'profile creation confirmation',
    eventInfo: {
      ucsId: 'UCS-bao-006',
      interaction: 'Confirmation:Your profile has been created successfully',
    },
    step: {
      stepId: '6',
      flowId: 'profile creation',
    },
  },
};
